import "./App.css";
import { useLocation, Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PrivateRouteAdmin from "./PrivateRouteAdmin";
import PrivateCustomer from "./PrivateCustomer";
import Login from "./pages/user/Login";
// Admin
import HistoryBetAll from "./pages/admin/HistoryBetAll";
import BankAdmin from "./pages/admin/BankAdmin";
import Dashboard from "./pages/admin/Dashboard";
import Request from "./pages/admin/Request";
import Users from "./pages/admin/Users";
import Refund from "./pages/admin/Refund";
import Add from "./pages/admin/Add";
import ApprovalHistory from "./pages/admin/ApprovalHistory";
import Khuyenmai from "./pages/admin/Khuyenmai";
import UserProfile from "./pages/admin/UserProfile";
import Promo from "./pages/admin/Promo";
import ThongBao from "./pages/admin/ThongBao";
import Setting from "./pages/admin/Setting";
import Config from "./pages/admin/Config";
import SettingNotify from "./pages/admin/SettingNotify";
import Employee from "./pages/admin/Employee";
import AllEmployee from "./pages/admin/AllEmployee";
import AdminList from "./pages/admin/AdminList";
import UsersByEmployee from "./pages/admin/UsersByEmployee";
import SettingProfit from "./pages/admin/SettingProfit";
import HoaHong from "./pages/admin/HoaHong";
import HistoryCasino from "./pages/admin/HistoryCasino";
import HistoryTransfer from "./pages/admin/HistoryTransfer";
import TraThuong from "./pages/admin/TraThuong";
import BankOut from "./pages/admin/BankOut";
import SetXD45s from "./pages/admin/SetXD45s";
import SetXD60s from "./pages/admin/SetXD60s";
import SetXS75s from "./pages/admin/SetXS75s";
import SetXS120s from "./pages/admin/SetXS120s";
import SetTX45s from "./pages/admin/SetTX45s";
import SetTX60s from "./pages/admin/SetTX60s";
import SetTXMD5 from "./pages/admin/SetTXMD5";
import SetTXLive from "./pages/admin/SetTXLive";
import SetXDLive from "./pages/admin/SetXDLive";
import SetXDBlockchain45s from "./pages/admin/SetXDBlockchain45s";
import SetXDBlockchain60s from "./pages/admin/SetXDBlockchain60s";
import SetGreedy from "./pages/admin/SetGreedy";
import SetCatDog from "./pages/admin/SetCatDog";
import SetBaccarat60s from "./pages/admin/SetBaccarat60s";
import SetRongHo45s from "./pages/admin/SetRongHo45s";
import SetRongHo60s from "./pages/admin/SetRongHo60s";
import SetBauCua45s from "./pages/admin/SetBauCua45s";
import SetBauCua60s from "./pages/admin/SetBauCua60s";
import OnlineUsers from "./pages/admin/OnlineUsers";
import Cleanup from "./pages/admin/Cleanup";
import ChatAdmin from "./pages/admin/Chat";
import AuditLogs from "./pages/admin/AuditLogs";
import Permissions from "./pages/admin/Permissions";
import Lobbies from "./pages/admin/Lobbies";
import LoginHistory from "./pages/admin/LoginHistory";
import GamePresets from "./pages/admin/GamePresets";
// Customer
import DashboardCustomer from "./pages/customer/DashboardCustomer";

import CustomerSetTX45s from "./pages/customer/SetTX45s";
import CustomerSetTX60s from "./pages/customer/SetTX60s";
import CustomerSetTXmd5 from "./pages/customer/SetTXMD5";
import CustomerSetXD45s from "./pages/customer/SetXD45s";
import CustomerSetXD60s from "./pages/customer/SetXD60s";
import CustomerSetXS75s from "./pages/customer/SetXS75s";
import CustomerSetXS120s from "./pages/customer/SetXS120s";

import UsersByEmployeeNV from "./pages/customer/UsersByEmployeeNV";
import HistoryBetAllCustomer from "./pages/customer/HistoryBetAllCustomer";
import HistoryCasinoCustomer from "./pages/customer/HistoryCasinoCustomer";

function App() {
    const location = useLocation();
    return (
        <div className="App">
            <Routes>
                <Route element={<Login />} path="/" />
                <Route element={<Login />} path="/login" />
                <Route path="/admin" element={<PrivateRouteAdmin />}>
                    {/* Admin */}
                    <Route element={<Dashboard />} path="/admin" exact />
                    <Route element={<HistoryCasino />} path="/admin/historyapi" exact />
                    <Route element={<HistoryCasino />} path="/admin/report-api/bet" exact />
                    <Route element={<HistoryTransfer />} path="/admin/report-api/history-transfer" exact />
                    <Route element={<HistoryTransfer />} path="/admin/history-transfer" exact />
                    <Route element={<HistoryBetAll />} path="/admin/history" exact />
                    <Route element={<Request />} path="/admin/request" exact />
                    <Route element={<Promo />} path="/admin/promo" exact />
                    <Route element={<Khuyenmai />} path="/admin/khuyenmai" exact />
                    <Route element={<Add />} path="/admin/add" exact />
                    <Route element={<ApprovalHistory />} path="/admin/approval-history" exact />
                    <Route element={<Refund />} path="/admin/refund" exact />
                    <Route element={<Users />} path="/admin/users" exact />
                    <Route element={<OnlineUsers />} path="/admin/online-users" exact />
                    <Route element={<UserProfile />} path="/admin/user/:id" />
                    <Route element={<AllEmployee />} path="/admin/allNV" exact />
                    <Route element={<AdminList />} path="/admin/admin-list" exact />
                    <Route element={<Employee />} path="/admin/employee" exact />
                    <Route element={<UsersByEmployee />} path="/admin/employee/:id" />
                    <Route element={<Setting />} path="/admin/setting" exact />
                    <Route element={<Config />} path="/admin/config" exact />
                    <Route element={<SettingProfit />} path="/admin/setting/profit" exact />
                    <Route element={<HoaHong />} path="/admin/setting/money" exact />
                    <Route element={<SettingNotify />} path="/admin/settingnotify" exact />
                    <Route element={<BankAdmin />} path="/admin/bank" exact />
                    <Route element={<ThongBao />} path="/admin/notification" />
                    <Route element={<TraThuong />} path="/admin/trathuong" />
                    <Route element={<BankOut />} path="/admin/bankout" />
                    <Route element={<SetXD45s />} path="/admin/setxd45s" />
                    <Route element={<SetXD60s />} path="/admin/setxd60s" />
                    <Route element={<SetXS75s />} path="/admin/setxs75s" />
                    <Route element={<SetXS120s />} path="/admin/setxs120s" />
                    <Route element={<SetTX45s />} path="/admin/settx45s" />
                    <Route element={<SetTX60s />} path="/admin/settx60s" />
                    <Route element={<SetTXMD5 />} path="/admin/settxmd5" />
                    <Route element={<SetTXLive />} path="/admin/settxlive" />
                    <Route element={<SetXDLive />} path="/admin/setxdlive" />
                    <Route element={<SetXDBlockchain45s />} path="/admin/setxdblockchain45s" />
                    <Route element={<SetXDBlockchain45s />} path="/admin/set-xdblockchain45s" />
                    <Route element={<SetXDBlockchain60s />} path="/admin/setxdblockchain60s" />
                    <Route element={<SetXDBlockchain60s />} path="/admin/set-xdblockchain60s" />
                    <Route element={<SetGreedy />} path="/admin/setgreedy" exact />
                    <Route element={<SetCatDog />} path="/admin/setcatdog" exact />
                    <Route element={<SetBaccarat60s />} path="/admin/set-baccarat60s" exact />
                    <Route element={<SetBaccarat60s />} path="/admin/setbaccarat60s" exact />
                    <Route element={<SetRongHo45s />} path="/admin/set-rongho45s" exact />
                    <Route element={<SetRongHo45s />} path="/admin/setrongho45s" exact />
                    <Route element={<SetRongHo60s />} path="/admin/set-rongho60s" exact />
                    <Route element={<SetRongHo60s />} path="/admin/setrongho60s" exact />
                    <Route element={<SetBauCua45s />} path="/admin/set-baucua45s" exact />
                    <Route element={<SetBauCua45s />} path="/admin/setbaucua45s" exact />
                    <Route element={<SetBauCua60s />} path="/admin/set-baucua60s" exact />
                    <Route element={<SetBauCua60s />} path="/admin/setbaucua60s" exact />
                    <Route element={<Cleanup />} path="/admin/cleanup" exact />
                    <Route element={<ChatAdmin />} path="/admin/chat" exact />
                    <Route element={<AuditLogs />} path="/admin/audit-logs" exact />
                    <Route element={<Permissions />} path="/admin/permissions" exact />
                    <Route element={<Lobbies />} path="/admin/lobbies" exact />
                    <Route element={<LoginHistory />} path="/admin/login-history" exact />
                    <Route element={<GamePresets />} path="/admin/game-presets" exact />
                </Route>
                <Route path="/customer" element={<PrivateCustomer />}>
                    {/* Nhân viên */}
                    <Route element={<DashboardCustomer />} path="/customer" exact />
                     <Route element={<CustomerSetXD45s />} path="/customer/setxd45s" exact />
                      <Route element={<CustomerSetXD60s />} path="/customer/setxd60s" exact />
                       <Route element={<CustomerSetXS75s />} path="/customer/setxs75s" exact />
                        <Route element={<CustomerSetXS120s />} path="/customer/setxs120s" exact />

                         <Route element={<CustomerSetTX45s />} path="/customer/settx45s" exact />
                          <Route element={<CustomerSetTX60s />} path="/customer/settx60s" exact />
                           <Route element={<CustomerSetTXmd5 />} path="/customer/settxmd5" exact />
                    <Route element={<UsersByEmployeeNV />} path="/customer/usercustomer" exact />
                    <Route element={<HistoryCasinoCustomer />} path="/customer/historyapi" exact />
                    <Route element={<HistoryBetAllCustomer />} path="/customer/history" exact />
                </Route>
            </Routes>
        </div>
    );
}

export default App;
